export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1 — About */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-white text-lg"></i>
              </div>
              <span className="text-lg font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                鲁鲁影院
              </span>
            </div>
            <p className="text-sm text-white/55 leading-relaxed">
              高清免费在线影视平台，提供最新电影、热播电视剧和综艺节目，无需缓冲，流畅追剧。每日更新海量内容，让你的观影体验更加精彩。
            </p>
          </div>

          {/* Column 2 — Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-white/55 hover:text-white transition-colors no-underline">首页</a></li>
              <li><a href="#cards" className="text-sm text-white/55 hover:text-white transition-colors no-underline">精选推荐</a></li>
              <li><a href="#ranking" className="text-sm text-white/55 hover:text-white transition-colors no-underline">热播排行</a></li>
              <li><a href="#topics" className="text-sm text-white/55 hover:text-white transition-colors no-underline">话题热议</a></li>
              <li><a href="#carousel" className="text-sm text-white/55 hover:text-white transition-colors no-underline">焦点专题</a></li>
            </ul>
          </div>

          {/* Column 3 — Categories */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-white/55">动作大片</span></li>
              <li><span className="text-sm text-white/55">悬疑推理</span></li>
              <li><span className="text-sm text-white/55">科幻巨制</span></li>
              <li><span className="text-sm text-white/55">浪漫爱情</span></li>
              <li><span className="text-sm text-white/55">高分经典</span></li>
            </ul>
          </div>

          {/* Column 4 — Partners */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              鲁鲁影院与多家优质内容平台保持密切合作，持续为用户提供丰富多元的影视资源。
              合作伙伴信息将陆续公布，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer no-underline">
                <i className="ri-mail-line text-white/70 text-sm"></i>
              </a>
              <a href="#comments" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer no-underline">
                <i className="ri-star-line text-white/70 text-sm"></i>
              </a>
              <a href="#faq" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer no-underline">
                <i className="ri-question-line text-white/70 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2026 鲁鲁影院 · 高清免费在线不缓冲 · 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/30">免费影视</span>
            <span className="text-xs text-white/30">高清在线</span>
            <span className="text-xs text-white/30">热播追剧</span>
          </div>
        </div>
      </div>
    </footer>
  );
}